<template>
  <el-dialog
    title="编辑用户"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    :close-on-click-modal="false"
  >
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto">
      <el-form-item label="账号" prop="account">
        <el-input v-model.trim="dataForm.account" placeholder="账号"></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="password">
        <el-input
          v-model.trim="dataForm.password"
          type="password"
          placeholder="不填表示不修改密码"
        ></el-input>
      </el-form-item>

      <el-form-item label="真实姓名" prop="username">
        <el-input v-model.trim="dataForm.username" placeholder="真实姓名"></el-input>
      </el-form-item>

      <el-form-item label="工号" prop="emp_no">
        <el-input v-model.trim="dataForm.emp_no" placeholder="工号"></el-input>
      </el-form-item>

      <el-form-item label="邮箱" prop="email">
        <el-input v-model.trim="dataForm.email" placeholder="邮箱"></el-input>
      </el-form-item>

      <el-form-item label="手机号" prop="phone">
        <el-input v-model.trim="dataForm.phone" placeholder="手机号"></el-input>
      </el-form-item>

      <!-- 角色 -->
      <el-form-item label="角色" prop="role">
        <el-checkbox-group v-model="dataForm.role">
          <el-checkbox
            v-for="role in roleList"
            :label="role.id"
            :key="role.id"
          >
            {{ role.role_name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="dataForm.gender">
          <el-radio :label="0">不显示</el-radio>
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">锁定</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="备注信息" prop="remark">
        <el-input type="textarea" :rows="2" v-model="dataForm.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditUser',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      roleListLoading: false,
      roleList: [], // 角色列表
      userId: '', // 用户ID
      dataForm: {
        id: '',           // 用户ID
        account: '',
        password: '',     // 可为空，表示不修改密码
        username: '',
        emp_no: '',
        email: '',
        phone: '',
        role: [],         // 已选角色 ID 数组
        gender: '',
        status: '',
        remark: ''
      },
      dataRule: {
        account: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        role: [
          { type: 'array', required: true, message: '请至少选择一个角色', trigger: 'change' }
        ],
        username: [
          { required: true, message: '真实姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          {
            validator: (rule, value, callback) => {
              if (!value) return callback(); // 空值不校验
              const phoneRegex = /^1[3-9]\d{9}$/;
              if (phoneRegex.test(value)) {
                callback();
              } else {
                callback(new Error('请输入正确的手机号'));
              }
            },
            trigger: 'blur'
          }
        ],
        email: [
          {
            validator: (rule, value, callback) => {
              if (!value) return callback(); // 空值，不校验，直接通过
              // 否则进行邮箱格式校验
              const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
              if (emailRegex.test(value)) {
                callback(); // 格式正确
              } else {
                callback(new Error('请输入正确的邮箱地址'));
              }
            },
            trigger: 'blur'
          }
        ]
      }
    };
  },

  methods: {
    // ✅ 打开弹窗：接收 row，提取 id，再从后端加载数据
    openDialog(row) {
      if (!row || !row.id) {
        this.$message.error('无效的数据，缺少 ID');
        return;
      }

      this.dialogVisible = true;
      this.dataForm.id = row.id;
      this.userId = row.id;

      // 清除旧数据
      this.resetForm();
      this.roleList = [];

      // 加载数据
      this.loadRoleList();
      this.loadUserData(row.id);

      // ✅ 使用 $nextTick 等待 DOM 更新，但加保护
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate();
        }
      });
    },

    // ✅ 重置表单
    resetForm() {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields();
      }
    },

    // ✅ 加载角色列表（带 userId 参数）
    loadRoleList() {
      this.roleListLoading = true;
      this.$axios
        .get('/api-30216/api/user/roles', {
          params: { userId: this.userId }
        })
        .then(res => {
          const data = res;
          // if (data.code === 200 && Array.isArray(data.data)) {
            this.roleList = data;

            // 自动设置已选角色（后端返回 checked: true 的角色）
            const selectedRoles = data
              .filter(role => role.checked)
              .map(role => role.id);
            this.dataForm.role = selectedRoles;
          // } else {
          //   this.$message.error(data.message || '角色列表获取失败');
          //   this.roleList = [];
          // }
        })
        .catch(err => {
          this.$message.error('请求角色列表失败');
          console.error(err);
          this.roleList = [];
        })
        .finally(() => {
          this.roleListLoading = false;
        });
    },

    // ✅ 加载用户详情
    loadUserData(userId) {
      this.$axios
        .get(`/api-30216/api/user/${userId}`)
        .then(res => {
          const data = res;
          if (data.code === 200 && data.data) {
            const user = data.data;
            this.dataForm.account = user.account;
            this.dataForm.username = user.username;
            this.dataForm.emp_no = user.emp_no;
            this.dataForm.email = user.email;
            this.dataForm.phone = user.phone;
            this.dataForm.gender = user.gender;
            this.dataForm.status = user.status;
            this.dataForm.remark = user.remark;
            // 注意：不回显密码
          } else {
            this.$message.error(data.message || '用户信息获取失败');
            this.dialogVisible = false;
          }
        })
        .catch(err => {
          this.$message.error('请求用户详情失败');
          console.error(err);
          this.dialogVisible = false;
        });
    },

    // ✅ 提交编辑（PUT 请求）
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return;

        // 构造提交数据
        const postData = {
          account: this.dataForm.account,
          username: this.dataForm.username,
          emp_no: this.dataForm.emp_no,
          email: this.dataForm.email,
          phone: this.dataForm.phone,
          gender: this.dataForm.gender, // ✅ 转为字符串
          status: this.dataForm.status, // ✅ 转为字符串
          remark: this.dataForm.remark,
          role_ids: this.dataForm.role,
        };

        // 如果密码不为空，则添加密码字段
        if (this.dataForm.password) {
          postData.password = this.dataForm.password;
        }

        this.submitLoading = true;
        // this.$axios
        //   .put(`/api-30216/api/user/${this.userId}`, postData)
         this.$axios
          .put(`/api-30216/api/user/${this.userId}`, postData, {
            headers: { 'Content-Type': 'application/json' },
            transformRequest: [postData => JSON.stringify(postData)]
          })
          .then(res => {
            const data = res;
            if (data.code === 200) {
              this.$message.success(data.message || '编辑成功');
              this.dialogVisible = false;
              this.$emit('success'); // 通知父组件刷新列表
            } else {
              this.$message.error(data.message || '编辑失败');
            }
          })
          .catch(err => {
            let errorMessage = '请求失败';
            if (err.response && err.response.data && err.response.data.message) {
              errorMessage = err.response.data.message;
            } else if (err.message) {
              errorMessage = err.message;
            }
            this.$message.error(errorMessage);
            console.error('编辑用户错误:', err);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>